module.exports = __webpack_public_path__ + "static/media/bar-vertical-stacked-icon.40eeb74b.svg";